<template lang="pug">
  #app(:class="skinColor")
    template(v-if="!isLoginPage")
      //- トースト格納用BOX
      .toast-box(data-testid="toast-box")
      .wrapper(v-if="reloader")
        //- ヘッダー
        router-view(name="header")

        //- サイドバー
        router-view(name="sidebar")

        //- メインコンテンツ
        .content-wrapper
          .container-fluid
            router-view(name="content")

        //- フッター
        router-view(name="footer")

        //- ポップアップ表示エリア
        portal-target(name="popup" multiple)

      a.btn.btn-default.bcard-page-top(href="#", :class="{'active': isScrollTopActive}", @click.prevent="scrollToTop")
        i.fa.fa-arrow-up.fa-fw
        | &nbsp;ページの先頭に戻る

      //- モーダルダイアログ表示エリア
      portal-target(name="modal" multiple)

    //- ログイン画面
    template(v-else)
      .login-page
        //- メインコンテンツ
        router-view(name="content")

        //- フッター
        router-view(name="footer")
</template>

<script>
import Vue from 'vue'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const TopRepository = RepositoryFactory.get('top')
const AnnouncementRepository = RepositoryFactory.get('announcement')

export default {
  name: 'App',
  data () {
    return {
      isScrollTopActive: false,
      reloader: true,
      // 運営からのお知らせ：未読件数
      countUnread: null
    }
  },
  computed: {
    skinColor () {
      // 代理操作画面
      if (this.isAgentPage) {
        return 'skin-black bcard-skin-agent'
      }
      // 機能管理モード
      else if (this.isMgmt) {
        return 'skin-green-light bcard-skin-manage'
      }
      // 管理画面
      else if (this.isAdminPage) {
        return 'skin-purple-light bcard-skin-admin'
      }
      // 一般画面
      else {
        return 'skin-black-light'
      }
    },
    isLoginPage () {
      return this.$route.name === 'login'
    },
    login_user () {
      return (this.$store.state.base.u && this.$store.getState('login_user')) || {}
    },
    useAdmin () {
      return this.login_user.is_admin
    }
  },
  created () {
    this.initPage()
    this.chkAdmin()

    // 運営からのお知らせ通知チェック
    this.chkAnnouncements()

    // 「ページの先頭に戻る」ボタン表示用スクロールイベント
    window.addEventListener('scroll', this.handleScroll)

    // ページから離れる前の確認
    window.addEventListener('beforeunload', this._beforeLeavePage)
  },
  updated () {
    // 画面高さ再計算（フッター位置調整）
    this.$nextTick(function () {
      const $layout = $('body').data('lte.layout')
      if ($layout) {
        $layout.fix()
      }
    })
  },
  destroyed () {
    // 「ページの先頭に戻る」ボタン表示用スクロールイベント
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('beforeunload', this._beforeLeavePage)
  },
  methods: {
    initPage () {
      // 初期化
      const vm = this

      const token = this.$store.getState('token')
      if (token) {
        Vue.ApiAdapter.setApiToken(token)
      }

      // 画面遷移した場合、intervalを解除する
      this.$store.commit('clearIntervals')
      // 機能遷移した場合、フラッシュメッセージを解除する
      this.$store.commit('setFlashMessages', [])

      // クッキーからサイドバーの開閉状態を取得する
      this.setSidebar()

      // すべてのトーストを削除する
      this.clearToast()

      TopRepository.get()
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            const data = vm.getApiData(response)
            const login_user = data.login_user
            vm.$store.commit('setInitInfo', {
              login_user: login_user,
              license: data.license,
              nisfa_integration: data.nisfa_integration,
              company_code: data.company_code,
              sid_corporate: data.sid_corporate,
              service_version: data.service_version,
              service_name: data.service_name,
              service_owner: data.service_owner,
              service_owner_url: data.service_owner_url,
              attachment_max_size: data.attachment_max_size
            })

            // ログインチェック
            vm.chkLogin(login_user)
          }
          else {
            // APPエラー時処理
            // eslint-disable-next-line no-console
            console.log(response)
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    clearToast () {
      const clearBtn = $('body').find('.toast-box').find('.toast-btn-clear')
      // トーストが表示されている場合、すべてのトーストを削除する
      for (let cnt = 0; cnt < clearBtn.length; cnt++) {
        // タイマーを解除するため、クリックイベントを実行する
        clearBtn[cnt].click()
      }
    },
    chkLogin (login_user) {
      // 未ログイン時はログイン画面へ
      if (!login_user) {
        // ログインユーザー情報が取れなかったらトークンを削除する
        Vue.ApiAdapter.clearApiToken()
        this.$store.commit('delToken')
        if (this.isLoginPage) {
          return
        }
        this.$router.push({name: 'login'})
        return
      }

      // ログイン後はログイン画面を表示せずにTOP画面へ遷移する
      if (this.isLoginPage) {
        this.$router.push({name: 'top'})
        return
      }

      // パスワード有効期限切れチェック
      // 有効期限切れの場合のメッセージを表示する
      // IEでanchorでの遷移が効かないためイベントを登録する
      if (login_user.is_pw_expired && !login_user.as_agent) {
        this.showToast('パスワードの有効期限が切れています。<br><span id="bcard-toast-link"><strong>プロフィール変更</strong></span> からパスワードの変更を行ってください。', { dest: 'ProfileSetting' })
      }
      else if (login_user.is_pw_need_change && !login_user.as_agent) {
        this.showToast('パスワードの有効期限はあと ' + login_user.days_to_pw_expire + ' 日です。<br><span id="bcard-toast-link"><strong>プロフィール変更</strong></span> からパスワードの変更を行ってください。', { dest: 'ProfileSetting' })
      }
    },
    chkAnnouncements () {
      // 非システム管理者、または代理中の場合、処理しない
      if (!this.useAdmin || this.isAgentPage) {
        return
      }

      // 運営からのお知らせ通知チェック
      const vm = this
      AnnouncementRepository.getUnreadCount()
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.countUnread = data.count

          // 未読の通知がある場合メッセージを表示
          if (vm.countUnread > 0) {
            vm.showToast('運営からのお知らせがあります。ご確認ください。', { type: 'info' })
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    handleScroll () {
      // スクロールがある程度スクロールされたらボタン表示
      this.isScrollTopActive = this.getScrollTop() > 100
    },
    chkAdmin () {
      // 一般ユーザーが「システム管理」または「機能管理」画面にアクセスした場合、Unauthorizedページに遷移させる
      if ((this.isAdminPage || this.isMgmt) && !this.$store.getState('login_user').is_admin) {
        this.$router.push({name: 'page-unauthorized'})
      }
    },
    /**
     * クッキーからサイドバーの開閉状態を取得する
     */
    setSidebar () {
      // クッキーに保存されている設定を取得する
      // 対象データが保存されていない あるいは closeの場合、クラスを追加する
      if (!this.isLoginPage && this.getCookie('sidebar_is_open') === '0') {
        // close
        document.body.classList.add('sidebar-collapse')
      }
      // 保存されている または openの場合、デフォルト表示する
      else {
        // open
        document.body.classList.remove('sidebar-collapse')
      }
    },
    _beforeLeavePage (e) {
      let confirmationMessage = ''
      if (this.isReloadGuardPage) {
        confirmationMessage = ' ' // ダイアログを表示するため文字列が必要
      }
      e.returnValue = confirmationMessage
      return confirmationMessage
    }
  }
}
</script>

<style lang="scss">
@import './assets/sass/style.scss'
</style>

<style lang="scss" scoped>
// [TOPへ戻る]ボタン
.bcard-page-top {
  position: fixed;
  right: 10px;
  bottom: 10px;
  padding: 10px 20px;

  background: #666;
  color: #fff;
  opacity: .8;
  display: none;
  z-index: 5;

  &:hover {
    background: #333;
    color: #fff;
  }

  &.active {
    display: inline-block;
  }

  // &:active,
  // &:focus,
  // &:active:focus {
  //   background: #111 !important;
  //   color: #fff !important;
  // }
}

.login-page {
  overflow: auto; /* 中身の背景色がmargin-topの分、欠けてしまったので */
  background-color: #ecf0f5;

  .main-footer {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue